<app-header></app-header>

<div style="text-align: center; margin: 20px;">

  <ng-container *ngIf="displayThankYou">
    {{"CUSTOMER_ACTION.THANK_YOU" | translate}}
  </ng-container>

  <ng-container *ngIf="!displayThankYou">
    <ng-container *ngIf="actionModel && actionModel.linkAction == 'addr-chg' && actionModel.needsConfirmation">
      <div>{{"CUSTOMER_ACTION.HELLO" | translate}} {{actionModel.customerFirstName}}, {{"CUSTOMER_ACTION.PLEASE_CONFIRM_IF_THIS_IS_YOUR_CURRENT_ADDRESS" | translate}}</div>

      <div style="margin: 15px;">
        <div *ngIf="actionModel.maskedLine1">{{actionModel.maskedLine1}}</div>
        <div *ngIf="actionModel.maskedLine2">{{actionModel.maskedLine2}}</div>
        <div *ngIf="actionModel.maskedLine3">{{actionModel.maskedLine3}}</div>

      </div>

      <div style="margin: 15px;">
        <button mat-raised-button color="accent" (click)="confirmAction()">{{"CUSTOMER_ACTION.NO_CHANGE_ADDRESS" | translate}}</button>
        &nbsp;&nbsp;
        <button mat-raised-button color="primary" (click)="denyAction()">{{"CUSTOMER_ACTION.YES_ADDRESS_CORRECT" | translate}}</button>
      </div>


    </ng-container>

    <ng-container *ngIf="actionModel && actionModel.linkAction == 'email-chg' && actionModel.needsConfirmation">
      <div>{{"CUSTOMER_ACTION.HELLO" | translate}} {{actionModel.customerFirstName}}, {{"CUSTOMER_ACTION.PLEASE_CONFIRM_TO_CHANGE_YOUR_EMAIL" | translate}}</div>

      <div style="margin: 15px;">
        <div *ngIf="actionModel.maskedLine1">{{actionModel.maskedLine1}}</div>
        <div *ngIf="actionModel.maskedLine2">{{actionModel.maskedLine2}}</div>
        <div *ngIf="actionModel.maskedLine3">{{actionModel.maskedLine3}}</div>

      </div>

      <div style="margin: 15px;">
        <button mat-raised-button color="primary" (click)="confirmAction()">{{"CUSTOMER_ACTION.YES_CHANGE_EMAIL" | translate}}</button>
        &nbsp;&nbsp;
        <button mat-raised-button color="accent" (click)="denyAction()">{{"CUSTOMER_ACTION.NO_DO_NOT_CHANGE_EMAIL" | translate}}</button>
      </div>


    </ng-container>

    <ng-container *ngIf="actionModel && actionModel.linkAction == 'email-conf'">
      <div>{{"CUSTOMER_ACTION.HELLO" | translate}} {{actionModel.customerFirstName}}</div>!
      <div style="margin-top: 30px;">
        {{"CUSTOMER_ACTION.YOUR_EMAIL_ADDRESS_HAS_BEEN_CONFIRMED" | translate}}
      </div>

    </ng-container>



  </ng-container>


</div>


